/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 10:55:08
 * @LastEditors: caiqin.xie
 * @message: FAQs-列表组件
 */
import React from "react";
import QuestionItem from '../../../components/FaqItem'
import styles from "../../index.module.scss";

interface Iquestion {
  id?: string;
  title?: string; // 标题
  detail?: string; // 内容详情
  [propName:string]: any;
}

interface IProps {
  questionList: Iquestion[]; // faq列表
  ctry: string;
  words: Record<string, string>
}

const FAQList = (props:IProps) => {
  const {questionList, ctry, words} = props
  return (
    <div className={styles['question-list']}>
      {questionList.map((item, index) => (
        <div className={styles['question-list-item']} key={index}>
          <QuestionItem ctry={ctry} words={words} {...item}></QuestionItem>
        </div>
      ))}
    </div>
  )
}
export default FAQList
